import script from "./ExpantionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpantionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ExpantionPanel.vue?vue&type=style&index=0&id=25453635&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25453635"]])

export default __exports__